import { useCallback } from "react";

import { Text } from "@vericus/cadmus-ui";

import { show } from "@ebay/nice-modal-react";
import { useParams } from "react-router-dom";

import studentWithTea from "@/assets/illustrations/student-with-tea.png";
import { LoadingPage } from "@/components/loading-page";
import { useAppDispatch } from "@/data/hooks";
import {
  SentimentCheckInput,
  useStudentSentimentChecksQuery,
} from "@/generated/graphql";

import { submitSentimentCheck } from "../actions";
import { SentimentCheckList } from "../components/sentiment-check-list";
import { SentimentCheckModal } from "../sentiment-check-modal";
import * as styles from "./sentiment-check-page.css";

export function SentimentCheckPage() {
  const { assessmentId } = useParams<{ assessmentId: string }>();
  const dispatch = useAppDispatch();

  const { data, loading, refetch } = useStudentSentimentChecksQuery({
    variables: { assessmentId: assessmentId! },
    skip: !assessmentId,
  });

  const intervals = data?.studentSentimentChecks ?? [];

  const handleSubmit = useCallback(() => {
    if (!assessmentId) return;

    show(SentimentCheckModal, {
      id: "sentiment-check-modal",
      onSubmit: async (input: SentimentCheckInput) => {
        await dispatch(submitSentimentCheck({ assessmentId, input }));
        refetch();
      },
    });
  }, [assessmentId, dispatch, refetch]);

  if (loading) {
    return <LoadingPage />;
  }

  if (intervals.length === 0) {
    return (
      <div className={styles.container}>
        <div className={styles.emptyState}>
          <Text kind="headingFour">No Sentiment Checks Available</Text>
          <Text kind="bodyLine" color="navy400">
            Sentiment checks will appear here once they become available for
            your assessment.
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.listContainer}>
        <SentimentCheckList intervals={intervals} onSubmit={handleSubmit} />
      </div>
      <div className={styles.illustrationContainer}>
        <img
          src={studentWithTea}
          alt="Student with tea"
          className={styles.illustration}
        />
      </div>
    </div>
  );
}

export default SentimentCheckPage;
